import React from 'react';
import { Stack } from '@atlaskit/primitives/compiled';

import { ListItemSkeleton } from '@townsquare/agg-list/skeleton';

export const LoadingState = (): React.ReactNode => {
	return (
		<Stack>
			<ListItemSkeleton />
			<ListItemSkeleton />
			<ListItemSkeleton />
			<ListItemSkeleton />
			<ListItemSkeleton />
		</Stack>
	);
};
